/**
 * Espaçamento e largura de conteúdo — alinhado ao vover-landing-page (HomePage + LandingHeader).
 */
export const LANDING_CONTAINER_MAX_WIDTH = 'lg' as const;

export const landingHeroSpacing = {
  pt: { xs: 14, md: 16 },
  pb: { xs: 8, md: 12 },
} as const;

export const landingSectionSpacing = {
  py: { xs: 8, md: 10 },
} as const;

export const landingFooterSpacing = {
  py: 4,
} as const;

export const landingGridSpacing = {
  hero: 4,
  cards: 3,
} as const;
